import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useSetPrintPreferences = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const setPrintPreferences = ({
    guid,
    labelType,
    identityShowType,
    code1Guid,
    code2Guid,
    showPacking,
    showDate,
    showDateTime,
    handleClose,
  }) => {
    setLoading(true);
    axiosClient
      .put(`Product/Branch/Packaging/Print/Preferences`, {
        guid,
        labelType,
        identityShowType,
        code1Guid,
        code2Guid,
        showPacking,
        showDate,
        showDateTime,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(res.data?.message, { variant: 'success' });
          handleClose();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [setPrintPreferences, loading];
};

export default useSetPrintPreferences;
